import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { Globals } from '../../globals';
import { Router } from '@angular/router';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { ToastrService } from 'ngx-toastr';
import { ClientsService } from 'app/services/client/ClientsService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';


@Component({
    selector: 'app-client-completed-assessments',
    templateUrl: './completed-assessments.component.html',
    styleUrls: ['./completed-assessments.component.scss'],
    providers: [DownloadAssessmentManager]
})
export class CompletedAssessmentsComponent implements OnInit {

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    rowSelection: string;

    height: number;
    count: number;
    loading: boolean = true;
    canSeeResults: boolean = false;

    constructor(
        private _ClientsService: ClientsService,
        private _Globals: Globals,
        private router: Router,
        private _DownloadAssessmentManager: DownloadAssessmentManager,
        private _toastr: ToastrService,
        public _CryptoJs: CryptoJs
    ) {
        this.rowSelection = "single";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        //get method
        this.getClientCompletedAssessments();
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canSeeResults = true;

        } else {
            this.canSeeResults = false;
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    seeResults() {
        if (this.canSeeResults) {
            let data = this.getSelectedRows();
            console.log(data);

            this.router.navigate(['/app/c_a_report', data[0].AssignmentId]);

        }
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    getClientCompletedAssessments() {
        this._ClientsService.getClientCompletedAssessments().subscribe((data: any) => {
            console.log('_GetClientCompletedAssessments', data);
            if (this._Globals.validationToken(data.result.Result))
            {
                let d = this._CryptoJs.decrypt(data.result.Data, this._Globals.lpassString);
                this.data = JSON.parse(d);

                this.loading = false;
                console.log("response_GetClientCompletedAssessments", data);
            }
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this._Globals.gridApis.push(this.gridApi);
        this.sizeToFit(this.gridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    createHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    width: 85,
        //    minWidth: 85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';

        //        content += '<i id="download_assessment" class="material-icons custom-icons">file_download</i>';

        //        content += '<i id="descriptionAction" class="material-icons">description</i>';

        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //    }
        //};
        //columnDefs.push(actionsHeader);

        //let checkHeader = {
        //    headerName: '',
        //    field: '',
        //    headerCheckboxSelection: true,
        //    headerCheckboxSelectionFilteredOnly: true,
        //    checkboxSelection: true,
        //    minWidth: 30,
        //    width: 30,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return '';
        //    }
        //};
        //columnDefs.push(checkHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'NicheName',
        //    minWidth: 175,
        //    width: 175,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        let version = params.data['MajorVersion'] + "." + params.data['MinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let coachHeader = {
            headerName: 'Coach',
            field: '',
            minWidth: 175,
            width: 175,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                let coach = params.data['CoachFirstName'] + " " + params.data['CoachLastName'];
                return coach;
            }
        };
        columnDefs.push(coachHeader);

        let completedHeader = {
            headerName: 'Completed on',
            field: 'CompletedOn',
            minWidth: 175,
            width: 175,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                console.log(params);
                return params.value
            },
            comparator: this.createDateComparator
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    createDateComparator(date1, date2) {
        date1 = new Date(date1.slice(0, -2) + ':00');
        date2 = new Date(date2.slice(0, -2) + ':00');

        console.log('comparator');
        return date2- date1;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            console.log("ClientCanSeeResults",data.ClientCanSeeResults);
            if (data.ClientCanSeeResults) {
                this.descriptionAction(data['AssignmentId']);
            } else {
                this._toastr.warning("You have not yet been given permissions by your coach to see your assessment results.","ELI");
            }


            

            //switch (e.event.target.id) {

            //    case "download_assessment":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.downloadAssessment(data['AssignmentId']);
            //            break;
            //        }
                     
            //    case "descriptionAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.descriptionAction(data['AssignmentId']);
            //            break;
            //        }
            //}
        }
    }

    downloadAssessment(assignmentId:number) {
        this._DownloadAssessmentManager.downloadReport(this._Globals.getUserId(), assignmentId, 3, this);
    }

    descriptionAction(assignmentId: number) {
        this.router.navigate(['/app/c_a_report', assignmentId]);
    }
    
}
